export const GOOGLE_ADS_CLICK_ID_KEYS = ['gclid', 'gbraid', 'wbraid'] as const

const GOOGLE_ADS_CLICK_ID_MAX_LENGTH = 256
const GOOGLE_ADS_CLICK_ID_PATTERN = /^[A-Za-z0-9_-]+$/

export function isGoogleAdsClickId(value: string | null): value is string {
  return Boolean(value && value.length <= GOOGLE_ADS_CLICK_ID_MAX_LENGTH && GOOGLE_ADS_CLICK_ID_PATTERN.test(value))
}
